import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SessionTimeout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let timeout: any;

    const resetTimer = () => {
      clearTimeout(timeout);
      const userType = sessionStorage.getItem("userType");
      const token = sessionStorage.getItem("token");
      timeout = setTimeout(() => {
        if (token) {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userId");
          sessionStorage.removeItem("userType");
          sessionStorage.removeItem("activepage");
          if (userType === "P") {
            navigate("/doctors");
          } else if (userType === "C"){
            navigate("/crmLogin");
          } else if (userType === "D") {
            navigate("/doctorLogin");
          } else {
            navigate("/");
          }
        }
      }, 10 * 60 * 1000);
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keypress", resetTimer);
    resetTimer();

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keypress", resetTimer);
    };
  }, [navigate]);

  return null;
};

export default SessionTimeout;
